import { render } from "./TopNav.vue?vue&type=template&id=4c154e7f"
import script from "./TopNav.vue?vue&type=script&lang=ts"
export * from "./TopNav.vue?vue&type=script&lang=ts"
script.render = render

export default script